<template>
  <v-navigation-drawer
    v-model="state"
    class="elevation-1"
    app
    :permanent="$vuetify.breakpoint.smAndUp"
    :temporary="$vuetify.breakpoint.xs"
  >
    <div
      class="d-flex align-center px-6"
      :class="{
        'mobile-drawer-logo': $vuetify.breakpoint.xs,
        'px-7': $vuetify.breakpoint.xs,
      }"
    >
      <div class="d-flex justify-center pl-0">
        <img height="64px" class="pa-2" src="https://d1tacsjrssg33t.cloudfront.net/images/ltt-logo-horizontal.png" />
      </div>
    </div>
    <v-divider></v-divider>
    <v-list class="py-0">
      <div>
        <!-- Hồ sơ tuyển sinh-->
        <v-list-group v-if="canViewGroup('cv')" prepend-icon="mdi-folder-account" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Hồ sơ tuyển sinh</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/admin/document" class="submenu-item" link v-if="$auth.policies['view-cv']">
            <v-list-item-title>QL Hồ sơ xét tuyển</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/document-cancel" class="submenu-item" link v-if="$auth.policies['view-cancel-cv']">
            <v-list-item-title>QL Hồ sơ đã hủy</v-list-item-title>
          </v-list-item>

          <v-divider/>

          <v-list-item
            to="/admin/incentive-review"
            class="submenu-item"
            link
            v-if="$auth.policies['view-incentive-review']"
          >
            <v-list-item-title>QL Xét duyệt ưu đãi</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/incentive-references"
            class="submenu-item"
            link
            v-if="$auth.policies['view-incentive-references']"
          >
            <v-list-item-title>QL Thông tin ưu đãi</v-list-item-title>
          </v-list-item>

          <v-divider/>

          <v-list-item
            to="/admin/document-template"
            class="submenu-item"
            link
            v-if="$auth.policies['view-document-template']"
          >
            <v-list-item-title>CH Thông tin trên hồ sơ</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/pdf-template" class="submenu-item" link v-if="$auth.policies['view-pdf-template']">
            <v-list-item-title>CH Biểu mẫu xác nhận</v-list-item-title>
          </v-list-item>

          <v-divider/>

          <v-list-item
            to="/admin/display-setting-step"
            class="submenu-item"
            link
            v-if="$auth.policies['view-step-display-setting']"
          >
            <v-list-item-title>CH Bước khai hồ sơ</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/direct-admission-product"
            class="submenu-item"
            link
            v-if="$auth.policies['view-admission-config']"
          >
            <v-list-item-title>CH Hệ tuyển thẳng</v-list-item-title>
          </v-list-item>

        </v-list-group>

        <!-- Thi và ksdgnl -->
        <v-list-group v-if="canViewGroup('exam')" prepend-icon="mdi-school" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>KS ĐGNL</v-list-item-title>
            </v-list-item-content>
          </template>

          <!-- 1. Cấu hình -->
          <v-list-item to="/admin/exams" class="submenu-item" link v-if="$auth.policies['manage-exam']">
            <v-list-item-title>QL Kỳ KSDGNL</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/exam-registration-rounds"
            class="submenu-item"
            link
            v-if="$auth.policies['manage-exam-registration-rounds']"
          >
            <v-list-item-title>QL Đợt đăng ký</v-list-item-title>
          </v-list-item>

          <!-- 2. Quản lý thí sinh -->
          <v-list-item to="/admin/students" class="submenu-item" link v-if="$auth.policies['manage-exam-students']">
            <v-list-item-title>QL Hồ sơ đăng ký</v-list-item-title>
          </v-list-item>

          <!-- Khối 1 tạm ẩn: xét duyệt ở QL Xét duyệt học sinh mầm non (/admin/preschool-review) -->
          <v-list-item
            to="/admin/direct-admissions-grade1"
            class="submenu-item"
            link
            v-if="false && $auth.policies['approve-direct-admissions-grade1']"
          >
            <v-list-item-title>Duyệt miễn thi khối 1</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/direct-admissions-grade6"
            class="submenu-item"
            link
            v-if="$auth.policies['approve-direct-admissions-grade6']"
          >
            <v-list-item-title>Duyệt miễn thi khối 6</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/direct-admissions-grade10"
            class="submenu-item"
            link
            v-if="$auth.policies['approve-direct-admissions-grade10']"
          >
            <v-list-item-title>Duyệt miễn thi khối 10</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <!-- 3. Tổ chức thi -->
          <v-list-item to="/admin/code" class="submenu-item" link v-if="$auth.policies['manage-exam-codes']">
            <v-list-item-title>QL Số túi & mã phách</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/absent" class="submenu-item" link v-if="$auth.policies['manage-exam-absences']">
            <v-list-item-title>QL Số Biên bản KS</v-list-item-title>
          </v-list-item>

          <!-- 4. Chấm thi -->
          <v-list-item to="/admin/markInput" class="submenu-item" link v-if="$auth.policies['input-exam-marks']">
            <v-list-item-title>QL Nhập điểm</v-list-item-title>
          </v-list-item>

          <!-- 5. Xem điểm -->
          <v-list-item to="/admin/markView" class="submenu-item" link v-if="$auth.policies['view-exam-marks']">
            <v-list-item-title>QL Điểm (sau khớp phách)</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>
          <!-- 5. Sau kỳ thi -->
          <v-list-item
            to="/admin/student-review"
            class="submenu-item"
            link
            v-if="$auth.policies['manage-student-reviews']"
          >
            <v-list-item-title>QL Phúc khảo</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item to="/admin/grade1-result" class="submenu-item" link v-if="$auth.policies['view-result-1']">
            <v-list-item-title>QL Kết quả KSĐGNL 1</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/grade6-result" class="submenu-item" link v-if="$auth.policies['view-result-6']">
            <v-list-item-title>QL Kết quả KSĐGNL 6</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/grade10-result" class="submenu-item" link v-if="$auth.policies['view-result-10']">
            <v-list-item-title>QL Kết quả KSĐGNL 10</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/statistics" class="submenu-item" link v-if="$auth.policies['view-exam-statistics']">
            <v-list-item-title> QL Báo cáo</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Trúng tuyển -->
        <v-list-group v-if="canViewGroup('admission')" prepend-icon="mdi-file-check-outline" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Kết quả tuyển sinh</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/admin/admission-list" class="submenu-item" link v-if="$auth.policies['view-admission-list']">
            <v-list-item-title>QL Hồ sơ trúng tuyển</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/preschool-review"
            class="submenu-item"
            link
            v-if="$auth.policies['view-direct-admission-review:grade-1']"
          >
            <v-list-item-title>QL Xét duyệt tuyển thẳng</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item
            to="/admin/direct-admission-review"
            class="submenu-item"
            link
            v-if="$auth.policies['view-direct-admission-review:grade-6'] || $auth.policies['view-direct-admission-review:grade-10']"
          >
            <v-list-item-title>QL Xét duyệt tuyển thẳng</v-list-item-title>
          </v-list-item> -->

          <v-list-item
            to="/admin/admission-review"
            class="submenu-item"
            link
            v-if="$auth.policies['view-admission-review']"
          >
            <v-list-item-title>QL Xét duyệt thủ công</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            to="/admin/admission-method"
            class="submenu-item"
            link
            v-if="$auth.policies['view-admission-config']"
          >
            <v-list-item-title>CH Phương thức TS</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/admission-formula"
            class="submenu-item"
            link
            v-if="$auth.policies['view-admission-config']"
          >
            <v-list-item-title>CH Công thức TS</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/admission-plan"
            class="submenu-item"
            link
            v-if="$auth.policies['view-admission-config']"
          >
            <v-list-item-title>CH Điều kiện trúng tuyển</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            to="/admin/display-setting-result-exam"
            class="submenu-item"
            link
            v-if="$auth.policies['view-result-display-setting']"
          >
            <v-list-item-title>CH Ẩn / hiện KQ</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item
            to="/admin/admission-variables"
            class="submenu-item"
            link
            v-if="$auth.policies['view-admission-config']"
          >
            <v-list-item-title>QL Biến tuyển sinh</v-list-item-title>
          </v-list-item> -->

        </v-list-group>

        <!-- Nhập học -->
        <v-list-group v-if="canViewGroup('enroll')" prepend-icon="mdi-file-document-edit-outline" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Quản lý nhập học</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            to="/admin/online-enrollment"
            class="submenu-item"
            link
            v-if="$auth.policies['view-online-enrollment']"
          >
            <v-list-item-title>QL Hồ sơ nhập học</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/update-expectation"
            class="submenu-item"
            link
            v-if="$auth.policies['view-update-expectation']"
          >
            <v-list-item-title>QL Chuyển đổi hệ ĐT</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/submit-document"
            class="submenu-item"
            link
            v-if="$auth.policies['view-submit-document']"
          >
            <v-list-item-title>QL Nhận hồ sơ gốc</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/enroll-forms"
            class="submenu-item"
            link
            v-if="
              $auth.policies['view-registration-form-1'] ||
                $auth.policies['view-registration-form-6'] ||
                $auth.policies['view-registration-form-10'] ||
                $auth.policies['view-cv']
            "
          >
            <v-list-item-title>QL Đơn nhập học</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/grade1-class-assignment"
            class="submenu-item"
            link
            v-if="
              $auth.policies['manage-primary-class-assignment'] ||
                $auth.policies['view-registration-form-6'] ||
                $auth.policies['view-registration-form-10'] ||
                $auth.policies['view-cv']
            "
          >
            <v-list-item-title>QL Xếp lớp</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/document-enroll-cancel"
            class="submenu-item"
            link
            v-if="$auth.policies['view-cancel-enroll-cv']"
          >
            <v-list-item-title>QL Đơn hủy nhập học</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/admin/enroll-capacity"
            class="submenu-item"
            link
            v-if="$auth.policies['view-enroll-capacity']"
          >
            <v-list-item-title>CH Chỉ tiêu tuyển sinh</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item to="/admin/appointment" class="submenu-item" link v-if="$auth.policies['view-appointment']">
            <v-list-item-title>QL Gửi giấy hẹn</v-list-item-title>
          </v-list-item> -->

          <v-list-item
            to="/admin/enrollment-window"
            class="submenu-item"
            link
            v-if="$auth.policies['view-enrollment-window']"
          >
            <v-list-item-title>QL Khóa / mở nhập học</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- CRM -->
        <v-list-group v-if="canViewGroup('crm')" prepend-icon="mdi-briefcase" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>CRM – Chuyển đổi Hồ sơ</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/admin/lead" class="submenu-item" link v-if="$auth.policies['view-lead']">
            <v-list-item-title>QL Hồ sơ tiềm năng</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/report" class="submenu-item" link v-if="$auth.policies['view-report-crm']">
            <v-list-item-title>QL Báo cáo</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/sale" class="submenu-item" link v-if="$auth.policies['view-sale-user']">
            <v-list-item-title>QL Nhân viên Sale</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Truyền Thông -->
        <v-list-group v-if="canViewGroup('communication')" prepend-icon="mdi-bullhorn" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Email & SMS</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/admin/email" class="submenu-item" link v-if="$auth.policies['view-email']">
            <v-list-item-title>Gửi Email</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/sms" class="submenu-item" link v-if="$auth.policies['view-sms']">
            <v-list-item-title>Gửi tin SMS</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item to="/admin/notification" class="submenu-item" link v-if="$auth.policies['view-notification']">
            <v-list-item-title>Gửi thông báo</v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item to="/admin/interviews" class="submenu-item" link v-if="$auth.policies['view-interviews']">
            <v-list-item-title>Phỏng vấn học bổng</v-list-item-title>
          </v-list-item> -->
        </v-list-group>

         <!-- Nội dung website -->
        <v-list-group v-if="canViewGroup('website')" prepend-icon="mdi-web" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Nội dung cổng tin</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            to="/admin/setting-banner"
            class="submenu-item"
            link
            v-if="$auth.policies['view-banner-setting']"
          >
            <v-list-item-title>QL Banner</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/bulletin-1" class="submenu-item" link v-if="$auth.policies['view-board-1']">
            <v-list-item-title>CH Thông tin tuyển sinh 1</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/bulletin-6" class="submenu-item" link v-if="$auth.policies['view-board-6']">
            <v-list-item-title>CH Thông tin tuyển sinh 6</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/bulletin-10" class="submenu-item" link v-if="$auth.policies['view-board-10']">
            <v-list-item-title>CH Thông tin tuyển sinh 10</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/instruction-1" class="submenu-item" link v-if="$auth.policies['view-instruction-1']">
            <v-list-item-title>CH Hướng dẫn tuyển sinh 1</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/instruction-6" class="submenu-item" link v-if="$auth.policies['view-instruction-6']">
            <v-list-item-title>CH Hướng dẫn tuyển sinh 6</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/instruction-10"
            class="submenu-item"
            link
            v-if="$auth.policies['view-instruction-10']"
          >
            <v-list-item-title>CH Hướng dẫn tuyển sinh 10</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/setting-popup"
            class="submenu-item"
            link
            v-if="$auth.policies['view-popup-setting'] || $auth.policies['view-banner-setting']"
          >
            <v-list-item-title>Ql Popup</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/enroll-news" class="submenu-item" link v-if="$auth.policies['view-information']">
            <v-list-item-title>QL Tin tức</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/survey-form" class="submenu-item" link v-if="$auth.policies['view-survey']">
            <v-list-item-title>QL Phiếu khảo sát</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Su Kien -->
        <v-list-group v-if="canViewGroup('event')" prepend-icon="mdi-calendar-star" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Sự kiện</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/admin/event" class="submenu-item" link v-if="$auth.policies['view-event-list']">
            <v-list-item-title>QL Sự kiện</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- QL Tài chính -->
        <v-list-group v-if="canViewGroup('finance')" prepend-icon="mdi-cash-multiple" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>QL Tài chính</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/admin/invoice-list" class="submenu-item" link v-if="$auth.policies['view-invoice']">
            <v-list-item-title>QL Hoá đơn</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/cash-payment" class="submenu-item" link v-if="$auth.policies['confirm-cash-payment']">
            <v-list-item-title>QL Giao dịch</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/application-fee" class="submenu-item" link v-if="$auth.policies['view-enroll']">
            <v-list-item-title>CH Phí mở hồ sơ</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/product-fees" class="submenu-item" link v-if="$auth.policies['view-product']">
            <v-list-item-title>CH Phí hệ đào tạo</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Báo cáo -->
        <v-list-group v-if="canViewGroup('report')" prepend-icon="mdi-chart-box" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Báo cáo chung</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/admin/dashboard" class="submenu-item" link v-if="$auth.policies['view-report']">
            <v-list-item-title>Xem BC thường xuyên</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/dashboard-chart" class="submenu-item" link v-if="$auth.policies['view-report-chart']">
            <v-list-item-title>Xem biểu đồ</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/annual-report" class="submenu-item" link v-if="$auth.policies['view-annual-report']">
            <v-list-item-title>Xem BC theo năm</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Quản lý người dùng -->
        <v-list-group v-if="canViewGroup('accounts')" prepend-icon="mdi-cog" class="report-group">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cài đặt hệ thống</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/admin/user" class="submenu-item" link v-if="$auth.policies['view-account']">
            <v-list-item-title>QL TK PH</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/users-management" class="submenu-item" link v-if="$auth.policies['account-settings']">
            <v-list-item-title>QL Người dùng / nhân sự</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/policies" class="submenu-item" link v-if="$auth.policies['policies-setting']">
            <v-list-item-title>QL Phân quyền</v-list-item-title>
          </v-list-item>

          <v-list-item to="/admin/product" class="submenu-item" link v-if="$auth.policies['view-product']">
            <v-list-item-title>QL Hệ đào tạo</v-list-item-title>
          </v-list-item>

          <v-list-item
            to="/admin/display-setting"
            class="submenu-item"
            link
            v-if="$auth.policies['view-display-setting']"
          >
            <v-list-item-title>CH Hiển thị chung</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import {mapGetters} from 'vuex'
import navigationPolicyGroups from '@/modules/policy/navigationPolicyGroups'

export default {
  props: {
    drawer: {type: Boolean},
  },
  created() {
    this.version = process.env.VUE_APP_API_VERSION
    this.isDevelopmentBuild = process.env.NODE_ENV === 'development'
  },
  data() {
    return {
      state: false,
      isDevelopmentBuild: true,
      version: '0.1',
    }
  },
  watch: {
    drawer() {
      this.state = true
    },
  },
  computed: {
    ...mapGetters('auth', ['user']),
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '32px'
        default:
          return '64px'
      }
    },
  },
  methods: {
    canViewGroup(groupValue) {
      const group = navigationPolicyGroups.find(item => item.value === groupValue)
      return Boolean(group && group.permission && this.$auth.policies[group.permission.code])
    },
  },
}
</script>

<style scoped>
.mobile-drawer-logo {
  height: 64px;
}
.active-item {
  background: #0d47a1;
  color: white !important;
}
#notice {
  position: absolute;
  bottom: 12px;
  left: 12px;
}
.submenu-item {
  padding-left: 48px !important;
}

.report-group .v-list-item__content {
  margin-left: -15px;
}
</style>
